import { HttpLink, split } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'

import { isStrapiRequest } from './utils'

export const getApolloLinks = ({ apiURL }: { apiURL: string }) => {
  const authLink = setContext(async (_, { headers: contextHeaders = {} }) => {
    if (typeof window === 'undefined') {
      try {
        const { cookies } = await import('next/headers')
        const cookieStore = await cookies()

        return {
          headers: {
            ...contextHeaders,
            cookie: cookieStore.toString(),
          },
        }
      } catch {
        // Fallback if next/headers is not available (e.g., in pages directory)
      }
    }

    return { headers: contextHeaders }
  })

  const apiURI = `${apiURL}/graphql`

  return [
    authLink,
    split(
      isStrapiRequest,
      new HttpLink({
        uri: process.env.NEXT_PUBLIC_STRAPI_API_URL + '/graphql',
      }),
      new HttpLink({
        uri: apiURI,
        credentials: 'include',
      })
    ),
  ]
}
